import { observer } from 'mobx-react-lite';
import React from 'react';
import { PrioritizedLocationCautionMarker } from '../../../common/components/location-caution-marker';
import {
    CautionLevelAttrId,
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../../socket/stream-types';
import { getEventQueueRowDataOrScheduledEventQueueRowData } from '../../utils/get-event-queue-row-data';

export const EventLocationCaution = observer(function EventLocationCaution({
    data,
    onClick,
}: {
    data: EventQueueRowData | UnitQueueRowData | ScheduledEventQueueRowData;
    onClick?: () => void;
}): React.ReactElement {
    const dataToUse = getEventQueueRowDataOrScheduledEventQueueRowData(data);
    if (
        dataToUse &&
        (dataToUse.highestPriorityLocationCaution || dataToUse.isNearbyLocationCautionPriority1)
    ) {
        return (
            <PrioritizedLocationCautionMarker
                onClick={onClick}
                highestPriorityLocationCaution={
                    dataToUse.highestPriorityLocationCaution as CautionLevelAttrId
                }
                isNearbyLocationCautionPriority1={dataToUse.isNearbyLocationCautionPriority1}
                size="sm"
            />
        );
    } else {
        return <></>;
    }
});
